import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { tabs } from "../../components";

import { UniversityAction } from "../../store/actions";

import ApplicationJourney from "./app-journey";
import Checklists from "./checklists";
import Deadlines from "./deadlines";
import General from "./general";
import Others from "./others";
import Programs from "./programs";
import Restaurants from "./restaurants";
import Scholarships from "./scholarships";
import TestScores from "./test-scores";

import "./styles.css";

const AddUniversity = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("1");
  const [state, setState] = useState({
    name: null,
    countryID: null,
    profilePic: null,
    campusPic: null,
    aboutUs: null,
    phone: null,
    email: null,
    website: null,
    address: null,
    courseLink: null,
    appLink: null,
    city: null,
    state: null,
    type: null,
    locationType: null,
    cityType: null,
    totalUgStudents: null,
    avgClassSize: null,
    researchOutput: null,
    acceptanceRate: null,
    facultyToStudentRatio: null,
    maleToFemaleRatio: null,
    scholAvail: null,
    avgFeesUSD: null,
    courseDuration: null,
    freshGradSalary: null,
    placementRate: null,
    facilitiesLink: null,
    halalOptions: null,
    trainDistance: null,
    busDistance: null,
    exchangeAvail: null,
    exchangeLink: null,
    percStudentsReceivingAid: null,
    avgFinancialAid: null,
    status: null,
    admissions: null,
    finance: null,
    rankings: null,
    requirements: null,
    subjectRanking: null,
    appJourneys: [],
    checklists: [],
    deadlines: [],
    programs: [],
    restaurants: [],
    scholarships: [],
    testScores: [],
    eligibility: [],
    recLetter: [],
    howToApply: [],
  });

  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const handleSubmit = () => {
    const payload = state;
    dispatch(UniversityAction.addUniversity(payload));
  };

  console.log(state);
  const tabsArray = [
    {
      label: <div className="uni-details-tabs-container">General</div>,
      key: "1",
      children: (
        <General
          state={state}
          setState={setState}
          setActiveTab={setActiveTab}
        />
      ),
    },
    {
      label: <div className="uni-details-tabs-container">Programs</div>,
      key: "2",
      children: (
        <Programs
          state={state}
          setState={setState}
          setActiveTab={setActiveTab}
        />
      ),
    },
    {
      label: <div className="uni-details-tabs-container">Test Scores</div>,
      key: "3",
      children: (
        <TestScores
          state={state}
          setState={setState}
          setActiveTab={setActiveTab}
        />
      ),
    },
    {
      label: <div className="uni-details-tabs-container">Scholarships</div>,
      key: "4",
      children: (
        <Scholarships
          state={state}
          setState={setState}
          setActiveTab={setActiveTab}
        />
      ),
    },
    {
      label: <div className="uni-details-tabs-container">Restaurants</div>,
      key: "5",
      children: (
        <Restaurants
          state={state}
          setState={setState}
          setActiveTab={setActiveTab}
        />
      ),
    },
    {
      label: (
        <div className="uni-details-tabs-container">Applications Journey</div>
      ),
      key: "6",
      children: (
        <ApplicationJourney
          state={state}
          setState={setState}
          setActiveTab={setActiveTab}
        />
      ),
    },
    {
      label: <div className="uni-details-tabs-container">Checklists</div>,
      key: "7",
      children: (
        <Checklists
          state={state}
          setState={setState}
          setActiveTab={setActiveTab}
        />
      ),
    },
    {
      label: <div className="uni-details-tabs-container">Deadlines</div>,
      key: "8",
      children: (
        <Deadlines
          state={state}
          setState={setState}
          setActiveTab={setActiveTab}
        />
      ),
    },
    {
      label: <div className="uni-details-tabs-container">Others</div>,
      key: "9",
      children: (
        <Others
          state={state}
          setState={setState}
          setActiveTab={setActiveTab}
          handleSubmit={handleSubmit}
        />
      ),
    },
  ];

  return (
    <div className="text-black">
      <tabs.UniversityTab
        key={activeTab}
        activeKey={activeTab}
        items={tabsArray}
        onChange={handleTabChange}
      />
    </div>
  );
};

export default AddUniversity;
